import '../layout/receipts';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter as Router } from 'react-router-dom';
import ReceiptPage from './components/receipts/receipt.page';
import docReady from '../receipts/docReady';
import { ReceiptProvider } from './components/receipts/context/receipt.context';
import { TrackingProvider } from '@jbhi-fi/components/src/Tracking';
import { getGtmData } from './components/customers/hooks/useVerifyLayout/helpers';
import { getCustomerTrackingData } from '../utils/event-tracking/event-data';
import { sassOptOut } from '../utils/sassOptOut';
import JbGlobalThemes from '@jbhi-fi/lanyard-ui/themes/jb/JbGlobalThemes';
import { trackPageView } from '@jbhi-fi/utils/src/ga360Tracking/functions/trackPageView';
import GlobalStyles from '@jbhi-fi/lanyard-ui/themes/GlobalStyles';

docReady(() => {
  const receiptWrapper = document.getElementById('receipts-wrapper');
  sassOptOut('forms');

  trackPageView({});

  if (receiptWrapper) {
    const root = createRoot(receiptWrapper);
    root.render(
      <>
        <GlobalStyles />
        <JbGlobalThemes />
        <ReceiptProvider>
          <Router>
            <TrackingProvider
              {...getGtmData()}
              pageType="eReceipts"
              group="digital receipt"
              getCustomerTrackingData={getCustomerTrackingData}
            >
              <ReceiptPage />
            </TrackingProvider>
          </Router>
        </ReceiptProvider>
      </>
    );
  }
});
